








































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import * as firebase from 'firebase';
import VueGallery from 'vue-gallery';
import { APP_CONFIG } from '@/config/app-config';
import utility from '@/utility/utility';
@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class ListProduct extends Vue {
    private eventEmit = {
        eventAddRow: 'eventAddRow',
        eventRemoveRow: 'eventRemoveRow'
    };

    @Prop({default: null})
    private listProducts: any;

    @Prop()
    private checkValid: any;

    private limit = 10000;
    private currentItem: any = null;
    private imageData: any = null;
    private uploadValue = 0;
    private hideImage = false;

    get currentTime() {
        return Date.now();
    }

    private async addRow() {
        if (this.listProducts.length >= this.limit) {
            return false;
        }
        this.$emit(this.eventEmit.eventAddRow, null);
    }

    private async removeRow(id: number) {
        this.$emit(this.eventEmit.eventRemoveRow, id);
    }

    private chooseImage(item) {
        this.currentItem = item;
        this.currentItem.image_origin = '';
        this.$refs.fileInput[0].click();
    }

    private previewImage(event) {
        this.uploadValue = 0;
        this.imageData = event.target.files[0];
        this.$refs.fileInput[0].value = null;
        this.onUpload()
    }

    private onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error => {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'File ảnh chỉ được tối đa 1Mb!',
                });
            },
            () => {
                this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.currentItem.image_origin =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    }

    private getImages(index) {
        return this.listProducts[index].image_origin;
    }
}
